import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PcpAuthModule } from "@pcp/auth";
import { VideoPlayerComponent } from "./components/video-player/video-player.component";
import { ConsumingPlayerDirective } from "./directives/consuming-player.directive";
import { VideoHotspotsComponent } from "./components/video-hotspots/video-hotspots.component";
import { SharedUiResizeObserverModule } from "shared/ui/resize-observer";
import { EffectsModule } from "@ngrx/effects";
import { ConnectWhileAuthenticatedEffects } from "./effects/connect-while-authenticated.effects";


@NgModule({
    imports: [
        CommonModule,
        PcpAuthModule,
        SharedUiResizeObserverModule,
        EffectsModule.forFeature([ConnectWhileAuthenticatedEffects]),
        VideoPlayerComponent,
        ConsumingPlayerDirective,
        VideoHotspotsComponent,
    ],
    exports: [
        VideoPlayerComponent,
        ConsumingPlayerDirective,
    ],
    providers: [],
})
export class PcpStreamingModule {
}
